import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

export const useIsInComparison = (productCode: string) => {
	const inCompareProducts = useSelector(selectors.compareItemsCodes)
	const isInComparison = inCompareProducts.includes(productCode)

	return isInComparison
}
